export const BANNER_RATIO_ERROR = 'Image must have a 16:9 aspect ratio (for example 1920 x 1080).';

export function hasAspectRatio(file: File, ratio = 16 / 9, tolerance = 0.02): Promise<boolean> {
    return new Promise((resolve) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(Math.abs(img.width / img.height - ratio) / ratio <= tolerance);
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            resolve(false);
        };
        img.src = url;
    });
}
